<template>
  <div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Search</label>
              <vs-input type="text" v-model="filters['search']" class="w-full"  />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Nimble User Role</label>
              <v-select multiple v-model="filters['type']" label="name" :options="customer_user_types" name="status"
                :reduce="option => option.name"/>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
        <vx-card title="CUSTOMER USERS">
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'customer-users-sheet'" :filters="fixed_filters_for_export" />
              <vs-button v-can="'create-edit-customer-users'"  @click="onClickCreateCustomerUser" class="mr-4" color="primary" type="filled">Create</vs-button>
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table id="customer-user-list-table" v-can="'view-customer-users'" max-items="10" :data="staff"  @sort="handleSort"   stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="20%" sort-key="first_name">CUSTOMER NAME</vs-th>
                <vs-th width="15%" sort-key="email">EMAIL</vs-th>
                <vs-th width="10%">LAST LOGGED</vs-th>
                <vs-th width="10%">NIMBLE USER ROLE</vs-th>
                <vs-th width="10%">CUSTOMER PORTAL ROLE</vs-th>
                <vs-th width="10%">PORTAL STATUS</vs-th>
                <vs-th width="8%">SAGE</vs-th>
                <vs-th width="2%"></vs-th>
                <vs-th width="15%" v-can="'create-edit-customer-users'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].first_name">
                    {{ data[indextr].title ? data[indextr].title : '' }} {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>


                  <vs-td :data="data[indextr].last_login_at">
                    {{ __dateTimeFormatter(data[indextr].last_login_at) }}
                  </vs-td>

                  <vs-td :data="data[indextr].types">
                    <span v-for="(item) in data[indextr].types" :key="item.id">
                      {{ item.name }}, 
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].role.name">
                    {{ data[indextr].role ? data[indextr].role.name : '-' }}
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip transparent :color="userListStatusColorFactory(data[indextr].status.id)">
                      {{data[indextr].status.name}}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <span v-if="data[indextr].sage_id" class="text-primary">
                      Ref: {{ data[indextr].sage_id }}
                    </span>
                  </vs-td>

                  <vs-td>
                    <span v-if="data[indextr].sage_id">
                      <vx-tooltip class="mr-2" :text="`Synchronise data with sage`" position="left">
                        <vs-button @click.stop="onClickUpdateSageContact(data[indextr])" size="small" 
                          color="primary" type="filled" icon-pack="feather" icon="icon-refresh-cw"/>
                      </vx-tooltip>
                    </span>
                    <span v-if="!data[indextr].sage_id && data[indextr].types.some(type => type.name === 'Accounts Payable') && sage_id">
                      <vx-tooltip class="mr-2" text="Create sage customer contact" position="left">
                        <vs-button @click.stop="onClickSageSyncContact(data[indextr])"
                                  size="small" color="danger" type="filled" icon-pack="feather" icon="icon-refresh-cw"/>
                      </vx-tooltip>
                    </span>
                  </vs-td>


                  <vs-td v-can="'create-edit-customer-users'">
                    <div class="vx-row">
                      <vx-tooltip text="View / Update user" position="left">
                        <vs-button class="ml-2" size="small"
                                   @click="onClickViewSupplier(data[indextr].id)"
                                    color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="!data[indextr].initial_invite_flag" text="Send customer user invitation" position="left">
                        <vs-button size="small" class="ml-2" @click.native="onClickCustomerUserInvitation(data[indextr].email)"
                                    color="primary" type="border" icon-pack="feather" icon="icon-send "></vs-button>
                      </vx-tooltip>

                      <vx-tooltip v-if="!data[indextr].email_verified_at && data[indextr].initial_invite_flag" text="Resend welcome email" position="left">
                        <vs-button size="small" class="ml-2" @click.native="onClickSupplierEmailResend(data[indextr].email)"
                                   color="primary" type="border" icon-pack="feather" icon="icon-rotate-ccw "></vs-button>
                      </vx-tooltip>

                      <vx-tooltip v-if="[3, 2].includes(data[indextr].status.id)" text="De-Activate user" position="left">
                        <vs-button class="ml-2" size="small" @click="openStatusChangeConfirm(data[indextr].id, 'de-activate')"
                           color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Activate user" position="left">
                        <vs-button @click="openStatusChangeConfirm(data[indextr].id, 'activate')"
                           v-if="[2, 4].includes(data[indextr].status.id)" class="ml-2" size="small"
                                   color="primary" type="border" icon-pack="feather" icon="icon-check"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip text="Delete user" position="left" v-can="'delete-customer-users'">
                        <vs-button class="ml-2" size="small" @click.stop="openDeleteConfirm(data[indextr].id)"
                           color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>

                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>
          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-user-pop-up ref="createCustomerUserPopUp"/>
    <update-customer-user-pop-up ref="updateCustomerUserPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  import CreateCustomerUserPopUp from '@/components/popups/customer-users/CreateCustomerUserPopUp'
  import UpdateCustomerUserPopUp from '@/components/popups/customer-users/UpdateCustomerUserPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import SageFactory from '@/mixins/SageFactory';
  import { mapActions, mapGetters } from 'vuex'
  import { updateSageCustomerContact } from '@/services/SageService'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff:  [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customer_id: null,
        fixed_filters_for_export : { customer_ids: [ Number(this.$route.params.id)  ] }
      }
    },
    props: {
      sage_id: {
        type: Number,
        default: null
      }
    },
    components: {
      'v-select': vSelect,
      CreateCustomerUserPopUp,
      UpdateCustomerUserPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages, SageFactory],
    async mounted () {
      this.customer_id = this.$route.params.id
      // this.$router.push({path: `/pages/manage-nimble/customers/${this.customer_id}?step=1`})
      // this.$vs.loading()
      // this.fetchUserList()
      // this.$vs.loading.close()
    },
    methods: {
      ...mapActions(['fetchCustomerUserTypes']),
      async refreshData () {
        this.fetchUserList()
      },

      async fetchUserList() {
        await this.$vs.loading({
          container: '#customer-user-list-table',
          scale: 0.45
        })
        try {
          const {data} = await CustomerRepository.getCustomerUsers(this.customer_id, this.page, this.filterQuery, 10, this.sort)
          this.staff =  data.data
          this.meta = data.meta
        } catch (error) {
          this.convertAndNotifyError(error)
        }
        this.$vs.loading.close('#customer-user-list-table > .con-vs-loading')
      },
      async onClickSupplierEmailResend (email) {
        await this.$vs.loading({
          container: '#customer-user-list-table',
          scale: 0.45
        })
        try {
          const {data} = await CustomerRepository.customerUserWelcomeEmailResend(email)
          this.showSuccessMessage('Email resend successfully!')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#customer-user-list-table > .con-vs-loading')
      },
      async onClickCustomerUserInvitation (email) {
        await this.$vs.loading({
          container: '#customer-user-list-table',
          scale: 0.45
        })
        try {
          const {data} = await CustomerRepository.customerUserInvitationSend(email)
          this.showSuccessMessage('Invitation sent successfully!')
          await this.fetchUserList()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#customer-user-list-table > .con-vs-loading')
      },

      openStatusChangeConfirm (id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: status === 'activate' ? 'success' : 'danger',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.changeUserStatus,
          parameters: [id, status]
        })
      },
      async changeUserStatus (params) {
        await this.$vs.loading({
          container: '#customer-user-list-table',
          scale: 0.45
        })
        try {
          await CustomerRepository.changeCustomerUserStatus(params[0], params[1])
          this.showSuccessMessage('Customer user status updated!')
          await this.fetchUserList()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#customer-user-list-table > .con-vs-loading')
      },

      openDeleteConfirm (id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm',
          text: 'Are you sure you want to delete this customer user?',
          accept: this.deleteCustomerUser,
          acceptText: 'Confirm',
          parameters: [id]
        })
      },
      async deleteCustomerUser (params) {
        const id = Array.isArray(params) ? params[0] : params
        await this.$vs.loading({
          container: '#customer-user-list-table',
          scale: 0.45
        })
        try {
          await CustomerRepository.deleteCustomerUser(id)
          this.showSuccessMessage('Customer user deleted successfully!')
          await this.fetchUserList()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#customer-user-list-table > .con-vs-loading')
      },
      onClickViewManufacturing(id) {
        this.$router.push({path: `/pages/manage-nimble/manufacturing/${id}`})
      },
      async onClickCreateCustomerUser () {
        await this.$refs.createCustomerUserPopUp.openPopup(this.customer_id, this.sage_id)
      },
      async onClickViewSupplier(id) {
        await this.$refs.updateCustomerUserPopUp.openPopup(id)
      },
      userListStatusColorFactory(status_id) {
        switch (status_id) {
          case 1:
            return 'dark';
          case 2:
            return 'warning';
          case 3:
            return 'primary'
          case 4:
            return 'danger'
        }
      },
      filterQueryUpdate (){
        this.fetchUserList()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchUserList()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchUserList()
        }
      },
      async onClickSageSyncContact(data) {
        await this.$vs.loading({
          container: '#customer-user-list-table',
          scale: 0.45
        })
        try {
          await this.createCustomerSageContact(this.sage_id, data)
          await this.fetchUserList()
        } catch (error) {
          
        }
        this.$vs.loading.close('#customer-user-list-table > .con-vs-loading')
      },
      async onClickUpdateSageContact(data) {
        await this.$vs.loading({
          container: '#customer-user-list-table',
          scale: 0.45
        })
        try {
          await updateSageCustomerContact(this.sage_id, data)
        } catch (error) {
          this.convertAndNotifyError(error)
        }
        this.$vs.loading.close('#customer-user-list-table > .con-vs-loading')
      }
    },
    computed: {
      ...mapGetters(['customer_user_types']),
    },
    watch : {
      page(){
        this.fetchUserList()
      }
    }
  }
</script>


<style scoped>

</style>
